/**
 * A19 — Secteurs Spécialisés: shared HTTP helpers for section API calls.
 */
import { API_BASE } from '../../../shared/utils/apiConfig';

export const apiCall = async (endpoint, method = 'GET', data = null) => {
  const base = (API_BASE || 'http://localhost:5001/api').replace(/\/$/, '');
  const options = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (data) options.body = JSON.stringify(data);

  const response = await fetch(`${base}${endpoint}`, options);
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || `HTTP error! status: ${response.status}`);
  return result;
};
